import React from "react";
import { motion } from "framer-motion";
import { SkillCard } from "../components";

const Skills = () => {
  return (
    <section
      id="skills"
      className="flex items-center justify-center flex-col gap-12 my-12"
    >
      {/* title */}
      <div className="w-full flex items-center justify-center py-24">
        <motion.div
          initial={{ opacity: 0, width: 0 }}
          animate={{ opacity: 1, width: 200 }}
          exit={{ opacity: 0, width: 0 }}
          transition={{ delay: 0.4 }}
          className="flex items-center justify-around w-52"
        >
          
          <p className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-secondary capitalize text-4xl lg:text-6xl font-serif tracking-widest">
            Skills
          </p>
         
        </motion.div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 w-full">
        <div className="w-full px-8 flex flex-col gap-4 items-start justify-start">
        <SkillCard
            skill={"HTML 5"}
            percentage={"95%"}
            color={"#fda4af"}
            move={true}
          />

          <SkillCard 
            skill={"CSS 3"} 
            percentage={"75%"} 
            color={"#a5b4fc"} 
          />

          <SkillCard
            skill={"Javascript"}
            percentage={"85%"}
            color={"#5eead4"}
            move={true}
          />

          <SkillCard 
            skill={"TypeScript"} 
            percentage={"80%"} 
            color={"#fef9c3"} 
          />

        </div>

        <div className="w-full px-8 flex flex-col gap-4 items-start justify-start">
         
          <SkillCard
            skill={"React & NextJs"}
            percentage={"80%"}
            color={"#e5e7eb"}
            move={true}
          />

          <SkillCard
            skill={"MySQL, Mongo DB & Firebase"}
            percentage={"70%"}
            color={"#818cf8"}
          />

          <SkillCard 
            skill={"Python"} 
            percentage={"75%"} 
            color={"#68a8d9"} 
            move={true}
          />

          <SkillCard
            skill={"Progress OpenEdge"}
            percentage={"85%"}
            color={"#ce9bdb"}
          />
        </div>
      </div>
    </section>
  );
};

export default Skills;
